import type { ShiftProductionForm } from "../../../shared/shift-production-form/contracts";

/** Analysis must show the immutable revision used by its report, never an open draft. */
export function analysisApprovedForm(form: ShiftProductionForm, revisionNumber: number | undefined): ShiftProductionForm | null {
  const revision = form.revisions.find(item => item.revisionNumber === revisionNumber);
  const approval = form.decisions.find(item => item.revisionNumber === revisionNumber
    && item.stage === "PRODUCTION_MANAGER" && item.decision === "APPROVED");
  if (!revision || !approval) return null;
  return {
    ...form,
    payload: revision.snapshot,
    submittedSnapshot: revision.snapshot,
    revisionNumber: revision.revisionNumber,
    submittedAt: revision.submittedAt,
    completedAt: approval.decidedAt,
    hasMissingMeasurements: revision.snapshot.products.some(product => product.measurements.some(item => item.state === "NOT_MEASURED")),
    status: "COMPLETED",
    currentApprovalStage: null,
    currentAssignedUserId: null,
    canDecide: false,
  };
}
